export const greenfields = {
  name: 'Green Fields',
  color: [0.3215686274509804, 0.2901960784313726, 0.22745098039215686, 1],
  bg: [0.5686274509803921, 0.5882352941176471, 0.21176470588235294, 1],
  grid1: [1, 0.9803921568627451, 0.8823529411764706, 1],
  grid2: [0.35294117647058826, 0.37254901960784315, 0.21568627450980393, 1],
}
